import api from './api';

const getHorarios = async () => {
  const { data } = await api.get('/horarios');
  return data;
};

const setHorarios = async (horariosData) => {
  const { data } = await api.post('/horarios', horariosData);
  return data;
};

const horarioService = {
  getHorarios,
  setHorarios,
};

export default horarioService;